module.exports = __webpack_public_path__ + "static/media/white.f5d55bc7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/white.jpeg
// module id = 2040
// module chunks = 0